import {
	mapMutations,
	mapState,
} from 'vuex'
import {
	ssoUrl,
	baseUrl,
} from '@/config/env'
import util from '@/config/util'
export default (Vue , options = {})=>{
	Vue.mixin({
		computed: {
			...mapState({
				pageCache: state => state?.common?.pageCache,
			}),
		},
	    methods:{
	    	...mapMutations([
	    		'SETPAGECACHE'
	    	]),
	    	configUrl(item){
				let url  = item.Url + item.KeyCode
				return url.replace('#/WebPage?url=','')
			},
	    	routerPush(args){
	    		if (typeof args == 'string') {
	    			this.$router.push(args)
	    		} else {
	    			let {path,query,params} = args
	    			if (params) {
	    				let pageKey = path.replace(/\?.+/,'').replace(/\//g,'_')
	    				let key = util.guid()
	    				this.SETPAGECACHE({
	    					pageKey,
	    					key,
	    					params,
	    				})
	    				query.ck = key
	    			}
	    			this.$router.push({path,query})
	    		}
	    	},
	    	getParams(){
	    		let ck = this.$route?.query?.ck
	    		let params = {}
				if(ck){
					let pageKey = this.$route.path.replace(/\?.+/,'').replace(/\//g,'_')
					if (this.pageCache[pageKey]) {
						params = this.pageCache[pageKey][ck]?.value
					}
					
				}
				return params
			},
			goLogin(shouldRedirect=true){
				if (!shouldRedirect) {
					location.href = `${ssoUrl}/sso/index.html#/hklogin?from=hk&`
					return
				}
				let redirect;
				let toUrl = this.$route.fullPath
				let regex = /token=\w*(&|$)|(\?|&)token=\w*$/;
				toUrl = toUrl.replace(regex, "");
				if (process.env.NODE_ENV === 'development') {
					redirect = escape(`http://localhost:9000/#${toUrl}`);
					location.href = `${ssoUrl}/sso/index.html#/hklogin?from=hk&redirect=${redirect}`;
				} else {
					redirect = escape(`${baseUrl}/client/index.html#${toUrl}`);
					location.href = `${ssoUrl}/sso/index.html#/hklogin?from=hk&redirect=${redirect}`;
				}
			},
	    },
  	})
}